import Vue from 'vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.register(ChartDataLabels);

Vue.use(Chartkick.use(Chart))

export default {
  setColors (colors) {
    Chartkick.options.colors = colors
  }
}
